<template>
  <header>
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="header-holder">
            <div class="left-header d-flex align-items-center">
<!--              <div class="header-info">-->
<!--                <div class="header-info-item">-->
<!--                  <p>{{ $static('header.space', 'Disk Space:') }}</p>-->
<!--                  <span>{{ info.free }}</span>-->
<!--                </div>-->
<!--              </div>-->
              <div class="header-info info-links">
                <div class="header-info-item">
                  <p>{{ $static('header.link', 'Перейти в магазин') }}</p>
                  <span><a :href="link" target="_blank">{{ $static('header.link1', 'Web версія') }}</a></span>
                  <span v-if="info.BOT_NAME"><a :href="'https://t.me/' + info.BOT_NAME"
                      target="_blank">{{ $static('header.link2', 'Telegram версія') }}</a></span>
                </div>
              </div>
              <div class="header-info info-filemanager" @click="openFileManager">
                <div class="header-info-item">
                  <Popper arrow :content="$static('header.filemanager', 'Відкрити файлменеджер')" hover
                    placement="right" style="white-space: nowrap">
                    <button class="btn-icon btn-icon-outline">
                      <span class="icon-loader-icons icon-loader-icons-folder-open"></span>
                    </button>
                  </Popper>
                </div>
              </div>

            </div>
            <!--icon's panel-->
            <div class="right-header">
              <div class="avatar-wrapper d-flex align-items-center">
              </div>
              <div class="logout">
                <a href="javascript:void(0)" @click.prevent.stop="logout">
                  <span class="icons">
                    <span class="icon icon-power"></span>
                  </span>
                  <span class="text">{{ $static('nav.logout', 'Вихід з панелі') }}</span>
                </a>
              </div>


            </div>
            <!--end icon's panel-->
          </div>
        </div>
      </div>
    </div>
  </header>
</template>
<script>

import api from '@/api'

export default {
  name: 'AdminHeader',
  computed: {
    info() {
      return this.$store.getters.info
    },
    link() {
      const { protocol, hostname } = globalThis.location;
      const parts = hostname.split('.');
      const baseHost = parts.length > 2 ? parts.slice(1).join('.') : hostname;

      return `${protocol}//${baseHost}`;
    }
  },
  methods: {
    openFileManager() {
      window.$('#file-manager').modal('show');
      this.$store.commit('onFileSelect', undefined)
    },
    logout() {
      api.get('/auth/logout')
        .then(
          () => {
            this.$router.push({ name: 'Login' })
          }
        )
    },
    getDate(str) {
      return new Date(str).toLocaleDateString();
    },
    byteInfo(bytes) {
      // console.log(bytes);
      let si_prefix = ['B', 'KB', 'MB', 'GB', 'TB', 'EB', 'ZB', 'YB'];
      let base = 1024;
      let si_class = Math.min(Math.log(bytes, base) | 0, si_prefix.length - 1);
      return (bytes / Math.pow(base, si_class)).toFixed(2) + ' ' + si_prefix[si_class];
    },
    getInfo() {
      api.get('/api/info')
        .then(response => response.data)
        .then(data => {
          this.$store.commit('setInfo', data)
          // this.info = data;
          // console.log('info', data)
        })
    }
  },
  mounted() {
    this.getInfo()
  }
}
</script>
